export default "__VITE_ASSET__FC3bdI8N__"